const ATTENDANCE_COLORS = {
  Present: "#9013FE",
  "Ex.tardy": "#007AFF",
  "Ex.absence": "#18CE0F",
  "Unex.tardy": "#FB8832",
  "Unex.absence": "#E6E5E6"
};

export { ATTENDANCE_COLORS };
